module.exports = __webpack_public_path__ + "static/media/icon_meeting.93acd9f7.svg";